import functions from "./functions.js";
let globalEventsInitiated = false;
let id = 0;
const instances = {};

const SimpleGuestsDefaults = {
	maxGuests: 100,
	maxChildren: 100,
	maxInfants: 100,
	childrenAge: 17,
	infantsAge: 12,
	adultMandatory: true,
	adultsLabel: 'Adults',
	childrenLabel: 'Children up to $y years',
	infantsLabel: 'Infants up to $y years',
	applyText: 'Apply',
	petsText: 'pets',
	showPets: 0,
	btnValueTpl: (adults, children, infants, guestsText, childrenText, petsText) => {
		return `${adults} ${guestsText}${infants || children ? ', ' + (infants + children) + ` ${childrenText}` : ''}${petsText}`;
	},
	// to do some logic on closing dropdown, return false to prevent change event on input
	onClose: () => {
		return true;
	}
};

class SimpleGuests {

	constructor(elem, options = {}) {
		this.id = ++id;
		instances[this.id] = this;

	  	this.elem = elem;
	  	this.$elem = $(elem);
		this.$parent = $(elem).closest('.dropdown, .form-group').attr('data-igid', this.id);
		this.$controls = this.$parent.find('.simple-guests-controls');
		this.$input = this.$parent.find('[type="hidden"]');
		this.$value = this.$elem.find('.simple-guests-value');

		this.isDropdown = this.$parent.hasClass('dropdown');

		
		this.setOptions(options);
		this.buildControls();

		if (this.showPets) {
			const petsChecked = this.$parent.find('[name="pets"]').is(':checked');
			this.petsText = petsChecked ? ', pets' : '';
		}
		
		this.setValue(this.$input[0].value);


		this.setEvents();
	}

	setOptions(options) {
		if ( !functions.isObject(options) ) {
			options = {};
		}

		// set properted from options or dom attributes
		this.maxGuests = +(options.maxGuests || this.$elem.attr('data-maxGuests') || SimpleGuestsDefaults.maxGuests);
		this.maxChildren = +(options.maxChildren || this.$elem.attr('data-maxChildren') || SimpleGuestsDefaults.maxChildren);
		this.maxInfants = +(options.maxInfants || this.$elem.attr('data-maxInfants') || SimpleGuestsDefaults.maxInfants);
		this.childrenAge = +(options.childrenAge || this.$elem.attr('data-childrenAge') || SimpleGuestsDefaults.childrenAge);
		this.infantsAge = +(options.infantsAge || this.$elem.attr('data-infantsAge') || SimpleGuestsDefaults.infantsAge);

		this.adultsLabel = (this.$elem.attr('data-adultsLabel') || SimpleGuestsDefaults.infantsAge);
		this.childrenLabel = (this.$elem.attr('data-childrenLabel') || SimpleGuestsDefaults.infantsAge);
		this.infantsLabel = (this.$elem.attr('data-infantsLabel') || SimpleGuestsDefaults.infantsAge);

		this.guestsText = (this.$elem.attr('data-guestsText') || 'guests');
		this.childrenText = (this.$elem.attr('data-childrenText') || 'children');

		this.showPets = +(this.$elem.attr('data-showPets') || this.showPets);
		this.petsText = (this.$elem.attr('data-petsText') || 'pets');
		this.petFriendlyText = (this.$elem.attr('data-petFriendlyText') || 'Pet friendly');
		this.luxuryPetText = (this.$elem.attr('data-luxuryPetText') || 'Luxury Pet Friendly Villas');
		this.yesText = (this.$elem.attr('data-yesText') || 'Yes');
		this.noText = (this.$elem.attr('data-noText') || 'No');

		this.applyText = this.$elem.attr('data-applyText') || SimpleGuestsDefaults.applyText;
		this.adultMandatory = Boolean(options.adultMandatory || this.$elem.attr('data-adultMandatory') || SimpleGuestsDefaults.adultMandatory);
		
		// set max childs
		let maxChilds = this.maxGuests - (this.adultMandatory ? 1 : 0);
		this.maxChildren = this.maxChildren > maxChilds ? maxChilds : this.maxChildren;
		this.maxInfants = this.maxInfants > maxChilds ? maxChilds : this.maxInfants;

		this.onClose = options.onClose || SimpleGuestsDefaults.onClose;
	}

	buildControls() {
		this.$adults = this.buildControl('adults', this.adultsLabel);
		this.$children = this.buildControl('children', this.childrenLabel, SimpleGuestsDefaults.childrenAge);
		this.$infants = this.maxInfants ? this.buildControl('infants', this.infantsLabel, SimpleGuestsDefaults.infantsAge) : null;

		const petsCheckbox = this.showPets ? `
			<div class="form-check form-switch">
				<div class="switch-yes-no">
					<div class="switch-yes">${this.yesText}</div>
					<input class="form-check-input" type="checkbox" role="switch" name="pets" value="1" id="petsSwitch">
					<div class="switch-no">${this.noText}</div>
				</div>
				<div class="row gx-2">
					<div class="col-auto">
						<i class="las la-paw la-lg text-warning"></i>
					</div>
					<div class="col">
						<label class="form-check-label" for="petsSwitch">${this.petFriendlyText}</label>
						<span class="form-check-label-desc">${this.luxuryPetText}</span>
					</div>
				</div>
			</div>
		` : '';

		this.$controls.append(this.$adults, this.$children, this.$infants, petsCheckbox, '<button type="button" class="btn btn-sm btn-primary fw-bold w-100 apply">' + this.applyText + '</button>');
		
		this.$controls.find('button[data-bs-toggle="dropdown"]').on('click', e => {
			$(e.target).parents('.simple-guests-controls').prev('.simple-guests[data-bs-toggle="dropdown"]').click();
		});
	}

	buildControl(name, label, years) {
		return $(`
			<div class="row align-items-center simple-guests-control" data-control="${name}">
				<div class="col" data-label>${label.replace('{{y}}', years)}</div>
				<div class="col-auto input-group align-items-center">
					<div class="input-group-prepend">
						<button tabindex="-1" class="btn btn-light" data-update="${name}" data-direction="-1" type="button">
							<i class="la la-minus"></i>
						</button>
					</div>
					<div data-value></div>
					<div class="input-group-append">
						<button tabindex="-1" class="btn btn-light" data-update="${name}" data-direction="1" type="button">
							<i class="la la-plus"></i>
						</button>
					</div>
				</div>
			</div>
		`);
	}

	getControlMinMax(name) {
		let min = name == 'adults' && this.adultMandatory ? 1 : 0;
		let max = this['max' + name[0].toUpperCase() + name.slice(1)] || this.maxGuests;
		let computedMax = this.maxGuests - (this.adults || 0) - (this.children || 0) - (this.infants || 0);
		computedMax = this[name] + computedMax;
		max = max > computedMax ? computedMax : max;
		return [min, max];
	}

	setValue(value) {
		value = value.split(',');
		let adults = value[0];
		let childs = value.slice(2).reduce((count, age) => {
			count[age] = (count[age] || 0) + 1;
			return count;
		}, {});

		this.setControlValue('adults', adults);
		this.setControlValue('children', childs[this.childrenAge]);
		this.$infants && this.setControlValue('infants', childs[this.infantsAge]);
		this.setInputValue();
	}

	setControlValue(name, value = 0) {
		const $control = this['$' + name];
		const [min, max] = this.getControlMinMax(name);
		value = +value;
		if ( value < min ) {
			value = min;
		}
		else if ( value > max ) {
			value = max;
		}

		this[name] = value;
		$control.find('[data-value]').html(value);
		this.checkUpdateBtns('adults');
		this.checkUpdateBtns('children');
		this.$infants && this.checkUpdateBtns('infants');
	}

	checkUpdateBtns(name) {
		const value = this[name];
		const [min, max] = this.getControlMinMax(name);
		this.$controls.find(`[data-update="${name}"][data-direction="-1"]`).prop('disabled', value == min);
		this.$controls.find(`[data-update="${name}"][data-direction="1"]`).prop('disabled', value == max);
	}

	setEvents() {
		// react on "outer input set value"
		this.$input.on('change', () => {
			this.setValue(this.$input[0].value);
		});

		this.$controls.on('click', '[data-update]', e => {
			const $btn = $(e.currentTarget);
			const name = $btn.attr('data-update');
			const value = this[name];
			const direction = +$btn.attr('data-direction');
			this.setControlValue(name, value + direction);
			this.setInputValue();
		});

		this.$parent.find('.apply').on('click', () => {
			this.$elem.dropdown('hide');
		});

		if ( !globalEventsInitiated ) {
			globalEventsInitiated = true;
			$(document).on('click', '.simple-guests-controls.dropdown-menu', e => {
				e.stopPropagation();
			});
			// ke kaco - doesnt work as jquery.on ...
			document.addEventListener('hide.bs.dropdown', e => {
				const $btn = $(e.target);
				const $dropdown = $btn.closest('.dropdown');
				const igid = $dropdown.attr('data-igid');

				if ( $btn.hasClass('show') && igid ) {
					instances[igid].close();
				}
			});
		}
	}

	setInputValue() {
		const value = [
			this.adults,
			this.children + (this.$infants ? this.infants : 0),
			...Array(this.children).fill(this.childrenAge),
			...(this.$infants ? Array(this.infants).fill(this.infantsAge) : [])
		];
		this.$input[0].value = value.join(',');
		this.$value.length && this.setBtnValue();
		!this.isDropdown && this.$input.trigger('change');
	}

	setBtnValue() {
		setTimeout(() => {
			const petsChecked = this.$parent.find('[name="pets"]').is(':checked');
			this.petsText = this.showPets && petsChecked ? ', pets' : '';
			this.$value.html(SimpleGuestsDefaults.btnValueTpl(this.adults, this.children, this.infants, this.guestsText, this.childrenText, this.petsText));
		});
	}
	// for public use
	getValue() {
		return this.$input[0].value;
	}
	// only if dropdown version
	close() {
		this.showPets && this.$parent.find('[name="pets"]').trigger('change');
		typeof this.onClose === 'function' && this.onClose() && this.$input.trigger('change');
	}

}

export {
	SimpleGuests,
	SimpleGuestsDefaults
};
